import { css, StyleSheet } from 'aphrodite';
import { AppBarHeight } from '../../../../components/AppBar/styles';
import { NAV_BAR_WIDTH_COMPACT, NAV_BAR_WIDTH_EXPANDED } from '../../../../constants/sizes';
import { background } from '../../../../styles/colors';
import { scrollbarBase } from '../../../../styles/styles';
/** Not for reuse */
export const AppGrid = ({ children }: { children: React.ReactNode }) => {
	return <div className={css(styles.appGridContainer)}>{children}</div>;
};
export const NavGridArea = ({ children }: { children: React.ReactNode }) => {
	return <div className={css(styles.nav)}>{children}</div>;
};
export const WarningGridArea = ({ children }: { children: React.ReactNode }) => {
	return <div className={css(styles.warning)}>{children}</div>;
};
export const AppBarGridArea = ({ children }: { children: React.ReactNode }) => {
	return <div className={css(styles.appBar)}>{children}</div>;
};
export const PageRootGridArea = ({ children }: { children: React.ReactNode }) => {
	return <div className={css(styles.pageRoot)}>{children}</div>;
};

const styles = StyleSheet.create({
	appGridContainer: {
		display: 'grid',
		maxHeight: '100vh',
		maxWidth: '100vw',
		minHeight: '100vh',
		minWidth: '100vw',
		overflow: 'hidden',
		gridTemplateColumns: 'auto 1fr auto',
		gridTemplateRows: 'auto auto 1fr',
		gridTemplateAreas: `
		"navigation warning warning"
		"navigation app-bar app-bar"
		"navigation content-root drawer"
		`,
		backgroundColor: background,
	},
	warning: {
		display: 'flex',
		flexDirection: 'column',
		gridArea: 'warning',
		minHeight: 0,
		position: 'relative',
		zIndex: 1000,
	},
	nav: {
		display: 'flex',
		gridArea: 'navigation',
		minWidth: NAV_BAR_WIDTH_COMPACT,
		maxWidth: NAV_BAR_WIDTH_EXPANDED,
		flexDirection: 'column',
		overflow: 'hidden',
	},
	appBar: {
		display: 'flex',
		gridArea: 'app-bar',
		width: '100%',
		overflow: 'hidden',
		maxHeight: AppBarHeight,
	},
	pageRoot: {
		gridArea: 'content-root',
		overflowY: 'auto',
		display: 'flex',
		height: '100%',
		minHeight: 0,
		...scrollbarBase,
	},
});
